import { SideMenu } from '../user-home/SideMenu';
import {CertificateLetters} from "./CertificateLetters";

export const CertificateLettersWrapper = () => {
  return (
    <div className="snn-user-home-main-wrapper">
      <SideMenu />
      <CertificateLetters />
    </div>
  );
};
